import React from 'react';
import {
  BarChart3,
  Bell,
  Building2,
  FileText,
  FolderKanban,
  History,
  Settings,
  Shield,
  Users,
} from 'lucide-react';
import RoleLayoutShell from './RoleLayoutShell';

const navItems = [
  {
    to: '/org-admin',
    label: 'Dashboard',
    Icon: Building2,
    exact: true,
  },
  {
    to: '/org-admin/members',
    label: 'Team Members',
    Icon: Users,
    anyPermissions: ['view_users'],
  },
  {
    to: '/org-admin/permissions',
    label: 'Permission Management',
    Icon: Shield,
    anyPermissions: ['manage_role_permissions'],
  },
  {
    to: '/org-admin/transactions',
    label: 'Transactions',
    Icon: FileText,
    anyPermissions: ['view_transactions'],
  },
  {
    to: '/org-admin/projects',
    label: 'Projects',
    Icon: FolderKanban,
    anyPermissions: ['view_projects'],
  },
  {
    to: '/org-admin/analytics',
    label: 'Analytics & Reports',
    Icon: BarChart3,
    anyPermissions: ['view_analytics', 'view_reports'],
  },
  {
    to: '/org-admin/history',
    label: 'History',
    Icon: History,
    anyPermissions: ['view_project_history'],
  },
  {
    to: '/org-admin/invitations',
    label: 'Invitations',
    Icon: Bell,
    anyPermissions: ['invite_users'],
  },
  {
    to: '/org-admin/settings',
    label: 'Org Settings',
    Icon: Settings,
    anyPermissions: ['manage_organization_settings'],
  },
];

const OrgAdminLayout = () => (
  <RoleLayoutShell
    title="EMS"
    subtitle="Org Management"
    navItems={navItems}
  />
);

export default OrgAdminLayout;
